<script>
import {mapActions, mapGetters} from "vuex";
import {
  getBusinessCardsDoc, getQueryEventCollection,
  queryConnectionsCollection,
  queryEventAttendeesCollection, queryEventCollection
} from "@/shared/firebase_utils";
import Loading from "@/components/Loading.vue";
import {getCountFromServer, getDocs, limit, query, startAfter, where} from "firebase/firestore";

export default {
  name: "MeetingsAnalyticsDetails",
  components: {Loading},
  data() {
    return {
      meetingsData: [],
      currentEventId: null,
      headers: [
        {
          text: "",
          value: "image",
          align: "end",
        },
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Business Name",
          value: "businessName",
          align: "start",
        },
        {
          text: "Job Title",
          value: "jobTitle",
          align: "start",
        },
        {
          text: "Meetings requested",
          value: "meetingsRequested",
          align: "start",
        }
      ],
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    breadCrumbItems() {
      if (this.currentEvent) {

        let items = [
          {
            text: "EventConnect",
            disabled: false,
            routeName: "MultiConnect",
            params: "",
          },
          {
            text: this.currentEvent.name,
            disabled: false,
            routeName: "editMultiConnect",
            params: {eventId: this.currentEvent.id},
            query: {tab: 5}
          },
          {
            text: 'Analytics',
            disabled: false,
            routeName: "editMultiConnect",
            params: {
              eventId: this.currentEvent.id,
            },
            query: {tab: 5}
          },
          {
            text: 'Meetings',
            disabled: true,
            routeName: "meetingAnalytics",
            params: {
              eventId: this.currentEvent.id,
            },
          },
        ];
        return items;
      } else return [];
    },
  },
  methods: {
    ...mapActions(["initializeCurrentEvent"]),
    handleRoute(item) {
      if (!item.disabled) {
        let route = {name: item.routeName, params: item.params};
        if (item.query) {
          route.query = item.query;
        }
        this.$router.push(route);
      }
    },
    async getMeetingDataWithAttendeeDetails(businessCardId, meetingsCount) {

      const attendeeBusinessCard = await getBusinessCardsDoc(businessCardId);
      if (attendeeBusinessCard.data()!==undefined) {
        return {
          displayImageUrl: attendeeBusinessCard.data().displayImageUrl,
          name: attendeeBusinessCard.data().firstName + ' ' + attendeeBusinessCard.data().lastName,
          businessName: attendeeBusinessCard.data().businessName,
          jobTitle: attendeeBusinessCard.data().jobTitle,
          meetingsRequested: meetingsCount,
        };
      }
    },
    async getMeetingsData() {
      let meetingsData = await getQueryEventCollection(
          where("parentMultiConnectEventId", "==", this.currentEventId),
          where('eventCategory', '==', 'superConnect')
      );
      const meetings = Object.groupBy(meetingsData.docs.map(doc => doc.data()), ({hostBusinessCardId}) => hostBusinessCardId);

      const meetingDetails = await Promise.all(Object.keys(meetings).map(businessCardId => this.getMeetingDataWithAttendeeDetails(businessCardId, meetings[businessCardId].length)));
      if (this.lastLoadedDocument) {
        meetingDetails.filter(meetingData => meetingData!==undefined).forEach(meeting => this.meetingsData.push(meeting));
      } else {
        this.meetingsData = meetingDetails.filter(meeting => meeting!==undefined);
      }
    },
    async saveEvent() {
      await this.initializeCurrentEvent(this.currentEventId);
      await this.getMeetingsData();
    }
  },
  created() {
    this.currentEventId = this.$route.params.eventId;
    this.saveEvent();
  }

}
</script>
<template>
    <v-container fluid :class="currentEvent == null || !this.meetingsData ? 'fill-height' : ''">
      <v-row v-if="currentEvent == null || !this.meetingsData">
        <v-col>
          <Loading/>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-breadcrumbs :items="breadCrumbItems" large>
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item
                  :disabled="item.disabled"
                  :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
                  @click="handleRoute(item)"
              >
                <div
                    :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
                >
                  {{ item.text }}
                </div>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="12">
          <v-card outlined min-height="110vh" class="px-8 py-4">
            <v-card-title>
              Meetings
            </v-card-title>
            <v-col>
              <v-row>

                  <div style="background-color: #F6F7FC; border-radius: 6px" class="ma-4">
                    <v-row class="ma-auto px-4 py-2" align="center">

                      <img src="@/assets/icons/group-discussion-meeting.svg" height="30" width="35" style="color: black"
                           class="pr-2">{{ this.currentEvent.analyticsData.meetings }} meetings created
                    </v-row>
                  </div>

              </v-row>
              <v-data-table
                  :headers="headers"
                  :items="meetingsData"
                  :items-per-page="-1"
                  hide-default-footer
              >
                <template v-slot:[`item.image`]="{ item }">
                  <v-avatar size="40">
                    <v-img :src="item.displayImageUrl"/>
                  </v-avatar>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <span>{{ item.name }}</span>
                </template>
                <template v-slot:[`item.businessName`]="{ item }">
                  <span>{{ item.businessName }}</span>
                </template>
                <template v-slot:[`item.jobTitle`]="{ item }">
                  <span>{{ item.jobTitle }}</span>
                </template>
                <template v-slot:[`item.meetingsRequested`]="{ item }">
                  <span>{{ item.meetingsRequested }}</span>
                </template>
              </v-data-table>


            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-container>


</template>

<style scoped>

</style>